import { CSSProperties } from "react";
import styles from "./Loading.module.css";

type LoadingProps = {
  visible: boolean;
  className?: string;
  style?: CSSProperties;
};

function Loading({ visible, className, style }: LoadingProps) {
  return <>
    {visible && 
      <div className={`${styles.loader} ${className}`} style={{ ...style }} />
    }
  </>;
}

export default Loading;
